const topics = [
  { label: '顶流塌房', heat: '980万', icon: 'ri-arrow-up-line', trend: 'up', color: 'text-primary-400' },
  { label: '财务造假', heat: '860万', icon: 'ri-arrow-up-line', trend: 'up', color: 'text-primary-400' },
  { label: '带货翻车', heat: '750万', icon: 'ri-arrow-up-line', trend: 'up', color: 'text-primary-400' },
  { label: '影视圈地震', heat: '690万', icon: 'ri-arrow-up-line', trend: 'up', color: 'text-accent-400' },
  { label: '网红人设崩塌', heat: '620万', icon: 'ri-arrow-up-line', trend: 'up', color: 'text-accent-400' },
  { label: 'AI换脸争议', heat: '580万', icon: 'ri-fire-line', trend: 'hot', color: 'text-primary-400' },
  { label: '裁判黑哨', heat: '540万', icon: 'ri-fire-line', trend: 'hot', color: 'text-accent-400' },
  { label: '明星税务', heat: '490万', icon: 'ri-arrow-right-up-line', trend: 'new', color: 'text-secondary-400' },
  { label: '选秀内幕', heat: '450万', icon: 'ri-arrow-right-up-line', trend: 'new', color: 'text-secondary-400' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            热议话题
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            当前全网讨论度最高的吃瓜话题标签，热度实时更新
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic, i) => (
            <a
              key={i}
              href="#cards"
              className="group inline-flex items-center gap-2 px-4 py-2.5 bg-background-100 border border-background-300/30 rounded-full hover:border-primary-500/30 transition-all cursor-pointer"
            >
              <i className={`${topic.icon} ${topic.color} text-sm`}></i>
              <span className="text-sm text-foreground-700 group-hover:text-foreground-900 transition-colors whitespace-nowrap">
                {topic.label}
              </span>
              <span className="text-xs text-foreground-500 bg-background-200 px-2 py-0.5 rounded-full whitespace-nowrap">
                {topic.heat}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}